import type {
  InstantSurveyType,
  SpecialtyInstantSurveyType,
  SurveyCategory,
} from '@api/instant_survey/types';

export interface LegacySurveyRoute {
  description: string;
  helpUrl: string;
  id: string;
  isSpecialty: boolean;
  label: string;
  path: string;
  prompts: InstantSurveyType['prompts'];
  searchPrompts: string[][];
}

export const mapSurveyTypeToRoute = ({
  description,
  helpUrl,
  hierarchy_search_prompts: searchPrompts,
  id,
  isSpecialty,
  name,
  prompts,
}: InstantSurveyType): LegacySurveyRoute => ({
  description,
  helpUrl,
  id,
  isSpecialty,
  label: name,
  path: id,
  prompts,
  searchPrompts,
});

export const RESEARCH_METHOD_CATEGORIES = [
  { id: 'purchase_based_segments', label: 'Purchase-Based Segments' },
  { id: 'concept_testing_and_new_item', label: 'Concept Testing & New Item' },
  { id: 'video_response_surveys', label: 'Video Response Surveys' },
  { id: 'advanced_methods', label: 'Advanced Methods' },
  { id: 'survey_labs', label: 'Survey Labs' },
] satisfies ReadonlyArray<{ id: SurveyCategory; label: string }>;

export const getSurveyTypesByCategory = (surveyTypes: InstantSurveyType[]) => {
  const specialtySurveyTypes = surveyTypes.filter(
    (surveyType): surveyType is SpecialtyInstantSurveyType => surveyType.isSpecialty
  );

  return RESEARCH_METHOD_CATEGORIES.flatMap((category) => {
    const types = specialtySurveyTypes.filter((surveyType) => surveyType.category === category.id);

    return types.length > 0 ? [{ ...category, surveyTypes: types }] : [];
  });
};

export const SURVEY_TABS = [
  {
    id: 'instant-surveys',
    label: 'Surveys',
    path: 'instant-surveys',
    target: 'package.instant_surveys',
    type: 'survey',
  },
  {
    id: 'survey-lab',
    label: 'Survey Labs',
    path: 'survey-lab',
    target: 'package.survey_lab',
    type: 'survey',
  },
];
